import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../models/dynamic-form-field';

@Component({
  selector: 'optsol-ngx-dynamic-radio-button',
  templateUrl: './dynamic-radio-button.component.html',
  styleUrls: ['./dynamic-radio-button.component.scss']
})
export class DynamicRadioButtonComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;

  constructor() {}

  ngOnInit() {}

}
